import * as fromDatatype from "../datatype-library/index";

export interface bl_cms_calendar_event_participant_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  calendar_event_guid: fromDatatype.GuidDataFieldInterface;
  calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  calendar_member_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  mst_grp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  app_mst_role_guid: fromDatatype.GuidDataFieldInterface;
  event_permission_json: fromDatatype.JsonDatatypeInterface;
  participant_email: fromDatatype.VarcharDatatypeInterface;
  participant_phone: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_cms_calendar_event_participant_link_RowClass
  implements bl_cms_calendar_event_participant_link_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  calendar_event_guid: fromDatatype.GuidDataFieldInterface;
  calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  calendar_member_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  mst_grp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  app_mst_role_guid: fromDatatype.GuidDataFieldInterface;
  event_permission_json: fromDatatype.JsonDatatypeInterface;
  participant_email: fromDatatype.VarcharDatatypeInterface;
  participant_phone: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
}
